
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/ethics",
      function () {
        return require("private-next-pages/legal/ethics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/ethics"])
      });
    }
  